export enum ActionType {
	// accounts= {
	ACCOUNTS_LOADED = 'ACCOUNTS_LOADED',
	ACCOUNTS_LOADING = 'ACCOUNTS_LOADING',
	CLOSE_CREATE_ACCOUNT_NOTIFICATION = 'CLOSE_CREATE_ACCOUNT_NOTIFICATION',
	CLOSE_EDIT_ACCOUNT_NOTIFICATION = 'CLOSE_EDIT_ACCOUNT_NOTIFICATION',
	CLOSE_NODE_RECALCULATED_NOTIFICATION = 'CLOSE_NODE_RECALCULATED_NOTIFICATION',
	CLOSE_NODE_WILL_RECALCULATE_NOTIFICATION = 'CLOSE_NODE_WILL_RECALCULATE_NOTIFICATION',
	CLOSE_NODE_ACCELERATED_NOTIFICATION = 'CLOSE_NODE_ACCELERATED_NOTIFICATION',
	CLOSE_ACCELERATED_NODES_NOTIFICATION = 'CLOSE_ACCELERATED_NODES_NOTIFICATION',
	CLOSE_DELETE_USER_NOTIFICATION = 'CLOSE_DELETE_USER_NOTIFICATION',
	CREATE_ACCOUNT_FAILED = 'CREATE_ACCOUNT_FAILED',
	CREATE_ACCOUNT_SUCCEEDED = 'CREATE_ACCOUNT_SUCCEEDED',
	DETACH_ACCOUNT_FROM_SYSTEM = 'DETACH_ACCOUNT_FROM_SYSTEM',
	DISABLE_CREATE_ACCOUNT_SUBMIT = 'DISABLE_CREATE_ACCOUNT_SUBMIT',
	DISABLE_EDIT_ACCOUNT_BUTTON = 'DISABLE_EDIT_ACCOUNT_BUTTON',
	EDIT_ACCOUNT_FAIL = 'EDIT_ACCOUNT_FAIL',
	EDIT_ACCOUNT_SUCCESS = 'EDIT_ACCOUNT_SUCCESS',
	GET_VISIBLE_SYSTEMS_FOR_ACCOUNT = 'GET_VISIBLE_SYSTEMS_FOR_ACCOUNT',
	TOGGLE_CREATE_ACCOUNT_BUTTON = 'TOGGLE_CREATE_ACCOUNT_BUTTON',
	PIN_ACCOUNT_FAILED = 'PIN_ACCOUNT_FAILED',
	PIN_ACCOUNT_SUCCEEDED = 'PIN_ACCOUNT_SUCCEEDED',
	CLOSE_PIN_ACCOUNT_NOTIFICATION = 'CLOSE_PIN_ACCOUNT_NOTIFICATION',
	UNREGISTER_FROM_MOBILE_APP = 'UNREGISTER_FROM_MOBILE_APP',
	CLEAR_ACCOUNT_DATA = 'CLEAR_ACCOUNT_DATA',
	DELETE_ACCOUNT_FAILED = 'DELETE_ACCOUNT_FAILED',
	DELETE_ACCOUNT_SUCCEEDED = 'DELETE_ACCOUNT_SUCCEEDED',
	// },
	// authentication= {
	LOGIN_FAILED = 'LOGIN_FAILED',
	LOGIN_SUCCESS = 'LOGIN_SUCCESS',
	LOGOUT = 'LOGOUT',
	SHOW_CARD = 'SHOW_CARD',
	SHOW_LOADING = 'SHOW_LOADING',
	TOGGLE_DISABLE_BUTTON = 'TOGGLE_DISABLE_BUTTON',
	// },
	// logs= {
	GET_LOGS = 'GET_LOGS',
	LOGS_LOADING = 'LOGS_LOADING',
	CONFIRMED_LOG = 'CONFIRMED_LOG',
	CONFIRMED_LOG_FAILED = 'CONFIRMED_LOG_FAILED',
	CONFIRMED_LOG_CLOSE_NOTIFICATION = 'CONFIRMED_LOG_CLOSE_NOTIFICATION',
	SHOW_LOGS_FOR_NODE = 'SHOW_LOGS_FOR_NODE',
	GET_SYSTEMS_NODES_SHORT = 'GET_SYSTEMS_NODES_SHORT',
	CLEAR_LOGS = 'CLEAR_LOGS',
	// },
	// map= {
	CLOSE_MAP_UPLOAD_NOTIFICATION = 'CLOSE_MAP_UPLOAD_NOTIFICATION',
	FAILED_UPLOAD_MAP_FILE = 'FAILED_UPLOAD_MAP_FILE',
	GET_SYSTEM_MAP = 'GET_SYSTEM_MAP',
	MAP_UPLOAD_FAILED = 'MAP_UPLOAD_FAILED',
	MAP_UPLOAD_SUCCESS = 'MAP_UPLOAD_SUCCESS',
	RESET_UPLOAD_MAP_FILE_STATUS = 'RESET_UPLOAD_MAP_FILE_STATUS',
	UPDATE_MAP_UPLOAD_PROGRESS = 'UPDATE_MAP_UPLOAD_PROGRESS',
	UPDATE_SECOND_MAP_UPLOAD_PROGRESS = 'UPDATE_SECOND_MAP_UPLOAD_PROGRESS',
	UPDATE_THIRD_MAP_UPLOAD_PROGRESS = 'UPDATE_THIRD_MAP_UPLOAD_PROGRESS',
	UPDATE_REPORT_MAP_UPLOAD_PROGRESS = 'UPDATE_REPORT_MAP_UPLOAD_PROGRESS',
	SAVE_POINTS_SUCCESSFULLY = 'SAVE_POINTS_SUCCESSFULLY',
	SAVE_POINTS_FAILED = 'SAVE_POINTS_FAILED',
	POLYGON_SAVE_SUCCESS = 'POLYGON_SAVE_SUCCESS',
	POLYGON_SAVE_FAILED = 'POLYGON_SAVE_FAILED',
	CLOSE_SAVE_POINTS_AND_POLYGONS_NOTIFICATION = 'CLOSE_SAVE_POINTS_AND_POLYGONS_NOTIFICATION',

	//system files
	UPDATE_FILE_UPLOAD_PROGRESS = 'UPDATE_FILE_UPLOAD_PROGRESS',
	FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS',
	FILE_UPLOAD_FAILED = 'FILE_UPLOAD_FAILED',
	RESET_UPLOAD_SYSTEM_FILE_STATUS = 'RESET_UPLOAD_SYSTEM_FILE_STATUS',
	FAILED_UPLOAD_SYSTEM_FILE = 'FAILED_UPLOAD_SYSTEM_FILE',
	FILE_DELETED = 'FILE_DELETED',
	GET_SYSTEM_FILE_ACCOUNTS = 'GET_SYSTEM_FILE_ACCOUNTS',
	SET_SYSTEM_FILE_ACCOUNTS = 'SET_SYSTEM_FILE_ACCOUNTS',

	// },
	// measurements= {
	CLOSE_NO_MEASUREMENTS_WARNING = 'CLOSE_NO_MEASUREMENTS_WARNING',
	MEASUREMENTS_LOADING = 'MEASUREMENTS_LOADING',
	// },
	// nodes= {
	CLOSE_CREATE_NODE_NOTIFICATION = 'CLOSE_CREATE_NODE_NOTIFICATION',
	CLOSE_DELETE_NODE_NOTIFICATION = 'CLOSE_DELETE_NODE_NOTIFICATION',
	CREATE_NODE = 'CREATE_NODE',
	CREATE_NODE_FAIL = 'CREATE_NODE_FAIL',
	CREATE_NODE_SUCCESS = 'CREATE_NODE_SUCCESS',
	DISABLE_NODE_SUBMIT = 'DISABLE_NODE_SUBMIT',
	DELETE_NODE_FAILED = 'DELETE_NODE_FAILED',
	DELETE_NODE_SUCCESSFULLY = 'DELETE_NODE_SUCCESSFULLY',
	SET_NODES_LOADING = 'SET_NODES_LOADING',
	TOGGLE_CREATE_NODE_BUTTON = 'TOGGLE_CREATE_NODE_BUTTON',
	BASE_NODE = 'BASE_NODE',
	CONFIGURE_NODE = 'CONFIGURE_NODE',
	IS_NODE_RECALCULATED = 'IS_NODE_RECALCULATED',
	ACCELERATE_NODE = 'ACCELERATE_NODE',
	INVERT_INCLINOMETER = 'INVERT_INCLINOMETER',
	SET_NODE_ACTIVE = 'SET_NODE_ACTIVE',
	BIND_DEVICE_TO_NODE_SUCCESS = 'BIND_DEVICE_TO_NODE_SUCCESS',
	BIND_DEVICE_TO_NODE_FAILED = 'BIND_DEVICE_TO_NODE_FAILED',
	CLOSE_BIND_DEVICE_NOTIFICATION = 'CLOSE_BIND_DEVICE_NOTIFICATION',
	// },
	// systems= {
	CLOSE_SAVE_PARAMETERS_SETTINGS_NOTIFICATION = 'CLOSE_SAVE_PARAMETERS_SETTINGS_NOTIFICATION',
	CLOSE_DELETE_SYSTEM_NOTIFICATION = 'CLOSE_DELETE_SYSTEM_NOTIFICATION',
	CLOSE_EMPTY_SYSTEM_ERROR = 'CLOSE_EMPTY_SYSTEM_ERROR',
	CREATE_SYSTEM = 'CREATE_SYSTEM',
	DISABLE_SYSTEM_SUBMIT = 'DISABLE_SYSTEM_SUBMIT',
	DELETE_SYSTEM_FAILED = 'DELETE_SYSTEM_FAILED',
	DELETE_SYSTEM_SUCCESSFULLY = 'DELETE_SYSTEM_SUCCESSFULLY',
	GET_SYSTEMS_FOR_INSTALLER_PANEL = 'GET_SYSTEMS_FOR_INSTALLER_PANEL',
	SET_SYSTEM_ARCHIVED_SUCCESSFULLY = 'SET_SYSTEM_ARCHIVED_SUCCESSFULLY',
	SET_SYSTEM_ARCHIVED_FAILED = 'SET_SYSTEM_ARCHIVED_FAILED',
	CLOSE_SET_SYSTEM_ARCHIVED_NOTIFICATION = 'CLOSE_SET_SYSTEM_ARCHIVED_NOTIFICATION',
	SHOW_FILTERED_NODES_NAMES = 'SHOW_FILTERED_NODES_NAMES',
	SHOW_FILTERED_NODES = 'SHOW_FILTERED_NODES',
	SHOW_FILTERED_SYSTEMS = 'SHOW_FILTERED_SYSTEMS',
	SHOW_FILTERED_SYSTEMS_NAMES = 'SHOW_FILTERED_SYSTEMS_NAMES',
	SHOW_SYSTEM_SEARCH_BAR = 'SHOW_SYSTEM_SEARCH_BAR',
	SHOW_FILTERED_SYSTEM_GROUPS = 'SHOW_FILTERED_SYSTEM_GROUPS',
	SHOW_FILTERED_SYSTEM_GROUPS_NAMES = 'SHOW_FILTERED_SYSTEM_GROUPS_NAMES',
	SHOW_SYSTEM_GROUP_SEARCH_BAR = 'SHOW_SYSTEM_GROUP_SEARCH_BAR',
	UPDATE_PICKED_SYSTEM_GROUP_NAME = 'UPDATE_PICKED_SYSTEM_GROUP_NAME',
	SAVE_SYSTEM_SETTINGS = 'SAVE_SYSTEM_SETTINGS',
	GET_FREE_SYSTEMS = 'GET_FREE_SYSTEMS',
	GET_SYSTEM_FULL = 'GET_SYSTEM_FULL',
	CLEAR_DASHBOARD_DATA = 'CLEAR_DASHBOARD_DATA',
	SYSTEM_SAVE_FAIL = 'SYSTEM_SAVE_FAIL',
	SYSTEM_SAVE_SUCCESSFULLY = 'SYSTEM_SAVE_SUCCESSFULLY',
	UPDATE_PICKED_SYSTEM_NAME = 'UPDATE_PICKED_SYSTEM_NAME',
	WAS_FETCHED_VISIBLE_SYSTEMS_FOR_ACCOUNT = 'WAS_FETCHED_VISIBLE_SYSTEMS_FOR_ACCOUNT',
	ARE_SYSTEMS_FETCHING = 'ARE_SYSTEMS_FETCHING',
	FETCH_SYSTEMS = 'FETCH_SYSTEMS',
	// },
	// users= {
	CLOSE_CONFIRMATION_MESSAGE_EXISTING_USER = 'CLOSE_CONFIRMATION_MESSAGE_EXISTING_USER',
	CLOSE_CONFIRMATION_MESSAGE_NEW_USER = 'CLOSE_CONFIRMATION_MESSAGE_NEW_USER',
	CONFIRMATION_FAILED_EXISTING_USER = 'CONFIRMATION_FAILED_EXISTING_USER',
	CONFIRMATION_FAILED_NEW_USER = 'CONFIRMATION_FAILED_NEW_USER',
	CONFIRMATION_SUCCESSFULLY_EXISTING_USER = 'CONFIRMATION_SUCCESSFULLY_EXISTING_USER',
	CONFIRMATION_SUCCESSFULLY_NEW_USER = 'CONFIRMATION_SUCCESSFULLY_NEW_USER',
	// },
	// view= {
	SET_DESKTOP_VIEW = 'SET_DESKTOP_VIEW',
	SET_MOBILE_VIEW = 'SET_MOBILE_VIEW',
	// },
	ACCEPT_PUSH_NOTIFICATIONS = 'ACCEPT_PUSH_NOTIFICATIONS',
	CLOSE_CLIENT_LOGO_NOTIFICATION = 'CLOSE_CLIENT_LOGO_NOTIFICATION',
	CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION',
	EDITING_TOGGLE = 'EDITING_TOGGLE',
	EMAIL_OR_PHONE_ALREADY_TAKEN = 'EMAIL_OR_PHONE_ALREADY_TAKEN',
	FETCH_ERROR = 'FETCH_ERROR',
	FAILED_UPLOAD_LOGO_FILE = 'FAILED_UPLOAD_LOGO_FILE',
	GET_FREE_DEVICES = 'GET_FREE_DEVICES',
	GET_DEVICES = 'GET_DEVICES',
	GET_GATEWAYS = 'GET_GATEWAYS',
	GET_SYSTEMS_MAPS_INFO = 'GET_SYSTEMS_MAPS_INFO',
	NOTIFICATION_CONFIRMED = 'NOTIFICATION_CONFIRMED',
	NOTIFICATION_SETTINGS_UPDATE = 'NOTIFICATION_SETTINGS_UPDATE',
	NOTIFICATION_SETTINGS_UPDATE_FAILED = 'NOTIFICATION_SETTINGS_UPDATE_FAILED',
	CLOSE_NOTIFICATION_SETTINGS_UPDATE = 'CLOSE_NOTIFICATION_SETTINGS_UPDATE',
	REFRESH_USER_NAME = 'REFRESH_USER_NAME',
	REJECT_PUSH_NOTIFICATIONS = 'REJECT_PUSH_NOTIFICATIONS',
	RESET_UPLOAD_LOGO_FILE_STATUS = 'RESET_UPLOAD_LOGO_FILE_STATUS',
	SAVE_CLIENT_LOGO_SUCCESSFULLY = 'SAVE_CLIENT_LOGO_SUCCESSFULLY',
	SAVE_CLIENT_LOGO_FAILED = 'SAVE_CLIENT_LOGO_FAILED',
	SAVE_PARAMETERS_SETTINGS_FAILED = 'SAVE_PARAMETERS_SETTINGS_FAILED',
	SAVE_PARAMETERS_SETTINGS_SUCCESSFULLY = 'SAVE_PARAMETERS_SETTINGS_SUCCESSFULLY',
	SHOW_NO_MEASUREMENTS_WARNING = 'SHOW_NO_MEASUREMENTS_WARNING',
	TOGGLE_REFRESH_BUTTON = 'TOGGLE_REFRESH_BUTTON',
	UPDATE_LOGO_UPLOAD_PROGRESS = 'UPDATE_MAP_UPLOAD_PROGRESS',
	TOGGLE_DISABLE_SEND_BUTTON = 'TOGGLE_DISABLE_SEND_BUTTON',
	GET_SYSTEMS = 'GET_SYSTEMS',
	GET_NODES = 'GET_NODES',
	GET_NODE = 'GET_NODE',
	CLEAR_NODE = 'CLEAR_NODE',
	GET_VISIBLE_ACCOUNTS = 'GET_VISIBLE_ACCOUNTS',
	GET_ACCOUNT = 'GET_ACCOUNT',
	TOGGLE_NOTIFICATION_POPPER = 'TOGGLE_NOTIFICATION_POPPER',
	TOGGLE_LOGOUT_POPPER = 'TOGGLE_LOGOUT_POPPER',
	SET_CURRENT_NODE_ID = 'SET_CURRENT_NODE_ID',
	SET_ASKED_ACCOUNT_ID = 'SET_ASKED_ACCOUNT_ID',
	CLEAR_EDIT_ACCOUNT_STATE = 'CLEAR_EDIT_ACCOUNT_STATE',
	GOTO_LOGS = 'GOTO_LOGS',
	TOGGLE_CHART_TYPE = 'TOGGLE_CHART_TYPE',
	CLOSE_ERROR = 'CLOSE_ERROR',
	FILTER_SYSTEMS = 'FILTER_SYSTEMS',
	EMAIL_EXISTS = 'EMAIL_EXISTS',
	GET_MY_ROLE = 'GET_MY_ROLE',
	VALIDATION_FAILURE = 'VALIDATION_FAILURE',
	VALIDATION_SUCCESS = 'VALIDATION_SUCCESS',
	SETTING_NEW_NODE_NAME_SUCCESS = 'SETTING_NEW_NODE_NAME_SUCCESS',
	SETTING_NEW_NODE_NAME_FAILED = 'SETTING_NEW_NODE_NAME_FAILED',
	CLOSE_SETTING_NEW_NODE_NAME_CARD = 'CLOSE_SETTING_NEW_NODE_NAME_CARD',
	EXPORT_START = 'EXPORT_START',
	EXPORT_STOP = 'EXPORT_STOP',
	RESETTING_PASSWORD_SUCCEED = 'RESETTING_PASSWORD_SUCCEED',
	RESETTING_PASSWORD_FAILED = 'RESETTING_PASSWORD_FAILED',
	RESET_PASSWORD_TIMEOUT_FAILED = 'RESET_PASSWORD_TIMEOUT_FAILED',
	CLOSE_EMAIL_NOTIFICATION = 'CLOSE_EMAIL_NOTIFICATION',
	CLOSE_SAVE_PASSWORD_NOTIFICATION = 'CLOSE_SAVE_PASSWORD_NOTIFICATION',
	GET_CENSORED_MAIL = 'GET_CENSORED_MAIL',
	GET_CENSORED_MAIL_FAIL = 'GET_CENSORED_MAIL_FAIL',
	GET_MEASUREMENTS = 'GET_MEASUREMENTS',
	UPDATE_ACCOUNT_PICKED_SYSTEM_NAME = 'UPDATE_ACCOUNT_PICKED_SYSTEM_NAME',
	SHOW_ACCOUNT_FILTERED_SYSTEMS = 'SHOW_ACCOUNT_FILTERED_SYSTEMS',
	SHOW_ACCOUNT_FILTERED_SYSTEMS_NAMES = 'SHOW_ACCOUNT_FILTERED_SYSTEMS_NAMES',
	SHOW_ACCOUNT_SYSTEM_SEARCH_BAR = 'SHOW_ACCOUNT_SYSTEM_SEARCH_BAR',
	GET_SYSTEM_FILES = 'GET_SYSTEM_FILES',
	GET_SYSTEM_FILE = 'GET_SYSTEM_FILE',
	GET_INSPECTIONS = 'GET_INSPECTIONS',
	UPDATE_INSPECTION_SUCCESS = 'UPDATE_INSPECTION_SUCCESS',
	UPDATE_INSPECTION_FAILED = 'UPDATE_INSPECTION_FAILED',
	CLOSE_UPDATE_INSPECTION_SUCCESS_NOTIFICATION = 'CLOSE_UPDATE_INSPECTION_SUCCESS_NOTIFICATION',
	CLOSE_UPDATE_INSPECTION_FAIL_NOTIFICATION = 'CLOSE_UPDATE_INSPECTION_FAIL_NOTIFICATION',
	CREATE_INSPECTION_SUCCESS = 'CREATE_INSPECTION_SUCCESS',
	CREATE_INSPECTION_FAILED = 'CREATE_INSPECTION_FAILED',
	CLOSE_CREATE_INSPECTION_SUCCESS_NOTIFICATION = 'CLOSE_CREATE_INSPECTION_SUCCESS_NOTIFICATION',
	CLOSE_CREATE_INSPECTION_FAIL_NOTIFICATION = 'CLOSE_CREATE_INSPECTION_FAIL_NOTIFICATION',
	DELETE_INSPECTION_SUCCESS = 'DELETE_INSPECTION_SUCCESS',
	DELETE_INSPECTION_FAILED = 'DELETE_INSPECTION_FAILED',
	GET_AGREEMENTS = 'GET_AGREEMENTS',
	UPDATE_AGREEMENT_SUCCESS = 'UPDATE_AGREEMENT_SUCCESS',
	UPDATE_AGREEMENT_FAILED = 'UPDATE_AGREEMENT_FAILED',
	CLOSE_UPDATE_AGREEMENT_SUCCESS_NOTIFICATION = 'CLOSE_UPDATE_AGREEMENT_SUCCESS_NOTIFICATION',
	CLOSE_UPDATE_AGREEMENT_FAIL_NOTIFICATION = 'CLOSE_UPDATE_AGREEMENT_FAIL_NOTIFICATION',
	CREATE_AGREEMENT_SUCCESS = 'CREATE_AGREEMENT_SUCCESS',
	CREATE_AGREEMENT_FAILED = 'CREATE_AGREEMENT_FAILED',
	CLOSE_CREATE_AGREEMENT_SUCCESS_NOTIFICATION = 'CLOSE_CREATE_AGREEMENT_SUCCESS_NOTIFICATION',
	CLOSE_CREATE_AGREEMENT_FAIL_NOTIFICATION = 'CLOSE_CREATE_AGREEMENT_FAIL_NOTIFICATION',
	DELETE_AGREEMENT_SUCCESS = 'DELETE_AGREEMENT_SUCCESS',
	DELETE_AGREEMENT_FAILED = 'DELETE_AGREEMENT_FAILED',
	GET_CLIENTS = 'GET_CLIENTS',
	GET_INSPECTION_PERFORMERS = 'GET_INSPECTION_PERFORMERS',
	GET_SERVICE_ACTIONS = 'GET_SERVICE_ACTIONS',
	UPDATE_SERVICE_ACTION_SUCCESS = 'UPDATE_SERVICE_ACTION_SUCCESS',
	UPDATE_SERVICE_ACTION_FAILED = 'UPDATE_SERVICE_ACTION_FAILED',
	CLOSE_UPDATE_SERVICE_ACTION_SUCCESS_NOTIFICATION = 'CLOSE_UPDATE_SERVICE_ACTION_SUCCESS_NOTIFICATION',
	CLOSE_UPDATE_SERVICE_ACTION_FAIL_NOTIFICATION = 'CLOSE_UPDATE_SERVICE_ACTION_FAIL_NOTIFICATION',
	CREATE_SERVICE_ACTION_SUCCESS = 'CREATE_SERVICE_ACTION_SUCCESS',
	CREATE_SERVICE_ACTION_FAILED = 'CREATE_SERVICE_ACTION_FAILED',
	CLOSE_CREATE_SERVICE_ACTION_SUCCESS_NOTIFICATION = 'CLOSE_CREATE_SERVICE_ACTION_SUCCESS_NOTIFICATION',
	CLOSE_CREATE_SERVICE_ACTION_FAIL_NOTIFICATION = 'CLOSE_CREATE_SERVICE_ACTION_FAIL_NOTIFICATION',
	DELETE_SERVICE_ACTION_SUCCESS = 'DELETE_SERVICE_ACTION_SUCCESS',
	DELETE_SERVICE_ACTION_FAILED = 'DELETE_SERVICE_ACTION_FAILED',
	GET_INSPECTION_SERVICE_ACTIONS = 'GET_INSPECTION_SERVICE_ACTIONS',
	GET_INSPECTION_SERVICE_ACTIONS_FAILED = 'GET_INSPECTION_SERVICE_ACTIONS_FAILED',
	CLEAR_INSPECTION_SERVICE_ACTIONS = 'CLEAR_INSPECTION_SERVICE_ACTIONS',
	GET_AUDIT_CHANGES_START = 'GET_AUDIT_CHANGES_START',
	GET_AUDIT_CHANGES = 'GET_AUDIT_CHANGES',
	GET_AUDIT_CHANGES_FAILED = 'GET_AUDIT_CHANGES_FAILED',
	GET_SYSTEMS_FOR_TABLE_START = 'GET_SYSTEMS_FOR_TABLE_START',
	GET_SYSTEMS_FOR_TABLE_FAILED = 'GET_SYSTEMS_FOR_TABLE_FAILED',
	CLEAR_SYSTEMS_FOR_TABLE = 'CLEAR_SYSTEMS_FOR_TABLE',
	GET_SYSTEM_DETAILS_START = 'GET_SYSTEM_DETAILS_START',
	GET_SYSTEM_DETAILS_FAILED = 'GET_SYSTEM_DETAILS_FAILED',
	GET_DEVICE_DETAILS_START = 'GET_DEVICE_DETAILS_START',
	GET_DEVICE_DETAILS_FAILED = 'GET_DEVICE_DETAILS_FAILED',
	GET_SERVICE_ACTION_ATTACHMENTS = 'GET_SERVICE_ACTION_ATTACHMENTS',
	GET_SERVICE_ACTION_ATTACHMENTS_FAILED = 'GET_SERVICE_ACTION_ATTACHMENTS_FAILED',
	CLEAR_SERVICE_ACTION_ATTACHMENTS = 'CLEAR_SERVICE_ACTION_ATTACHMENTS',
	CREATE_SERVICE_ACTION_ATTACHMENT_SUCCESS = 'CREATE_SERVICE_ACTION_ATTACHMENT_SUCCESS',
	CREATE_SERVICE_ACTION_ATTACHMENT_FAILED = 'CREATE_SERVICE_ACTION_ATTACHMENT_FAILED',
	DELETE_SERVICE_ACTION_ATTACHMENT_SUCCESS = 'DELETE_SERVICE_ACTION_ATTACHMENT_SUCCESS',
	DELETE_SERVICE_ACTION_ATTACHMENT_FAILED = 'DELETE_SERVICE_ACTION_ATTACHMENT_FAILED',
	GET_SERVICE_ACTION_PART_IMAGES = 'GET_SERVICE_ACTION_PART_IMAGES',
	GET_SERVICE_ACTION_PART_IMAGES_FAILED = 'GET_SERVICE_ACTION_PART_IMAGES_FAILED',
	CLEAR_SERVICE_ACTION_PART_IMAGES = 'CLEAR_SERVICE_ACTION_PART_IMAGES',
	CREATE_SERVICE_ACTION_PART_IMAGE_SUCCESS = 'CREATE_SERVICE_ACTION_PART_IMAGE_SUCCESS',
	CREATE_SERVICE_ACTION_PART_IMAGE_FAILED = 'CREATE_SERVICE_ACTION_PART_IMAGE_FAILED',
	DELETE_SERVICE_ACTION_PART_IMAGE_SUCCESS = 'DELETE_SERVICE_ACTION_PART_IMAGE_SUCCESS',
	DELETE_SERVICE_ACTION_PART_IMAGE_FAILED = 'DELETE_SERVICE_ACTION_PART_IMAGE_FAILED',
	GET_SYSTEMS_VERY_SHORT = 'GET_SYSTEMS_VERY_SHORT',
	CREATE_SYSTEM_GROUP = 'CREATE_SYSTEM_GROUP',
	DISABLE_SYSTEM_GROUP_SUBMIT = 'DISABLE_SYSTEM_GROUP_SUBMIT',
	GET_SYSTEM_GROUPS = 'GET_SYSTEM_GROUPS',
	DELETE_SYSTEM_GROUP_SUCCESSFULLY = 'DELETE_SYSTEM_GROUP_SUCCESSFULLY',
	DELETE_SYSTEM_GROUP_FAILED = 'DELETE_SYSTEM_GROUP_FAILED',
	CLOSE_DELETE_SYSTEM_GROUP_NOTIFICATION = 'CLOSE_DELETE_SYSTEM_GROUP_NOTIFICATION',
	GET_SYSTEMS_FOR_GROUP = 'GET_SYSTEMS_FOR_GROUP',
	GET_SYSTEM_GROUPS_INSTALLER = 'GET_SYSTEM_GROUPS_INSTALLER',
	ADD_SYSTEMS_TO_GROUP_SUCCEEDED = 'ADD_SYSTEMS_TO_GROUP_SUCCEEDED',
	ADD_SYSTEMS_TO_GROUP_FAILED = 'ADD_SYSTEMS_TO_GROUP_FAILED',
	CLOSE_ADD_SYSTEMS_TO_GROUP_NOTIFICATION = 'CLOSE_ADD_SYSTEMS_TO_GROUP_NOTIFICATION',
	ADD_ACCOUNTS_TO_SYSTEM_GROUP_SUCCEEDED ='ADD_ACCOUNTS_TO_SYSTEM_GROUP_SUCCEEDED',
	ADD_ACCOUNTS_TO_SYSTEM_GROUP_FAILED = 'ADD_ACCOUNTS_TO_SYSTEM_GROUP_FAILED',
	CLOSE_ADD_ACCOUNTS_TO_SYSTEM_GROUP_NOTIFICATION = 'CLOSE_ADD_ACCOUNTS_TO_SYSTEM_GROUP_NOTIFICATION',
	GET_ACCOUNTS_FOR_SYSTEM_GROUP = 'GET_ACCOUNTS_FOR_SYSTEM_GROUP',
	SHOW_FILTERED_SYSTEM_NAMES_FOR_GROUP = 'SHOW_FILTERED_SYSTEM_NAMES_FOR_GROUP',
	SET_RAINSTORM_MODE = 'SET_RAINSTORM_MODE',
	CLOSE_SET_RAINSTORM_MODE_NOTIFICAION = 'CLOSE_SET_RAINSTORM_MODE_NOTIFICAION',
	SAVE_W2_PARAMETERS_SETTINGS_SUCCESSFULLY = 'SAVE_W2_PARAMETERS_SETTINGS_SUCCESSFULLY',
	SAVE_W2_PARAMETERS_SETTINGS_FAILED = 'SAVE_W2_PARAMETERS_SETTINGS_FAILED',

	CLOSE_EXPORT_NOTIFICATION = 'CLOSE_EXPORT_NOTIFICATION',
	EXPORT_FAILED_NO_DATA = 'EXPORT_FAILED_NO_DATA',
	EXPORT_FAILED = 'EXPORT_FAILED',
	SEND_TEST_NOTIFICATION = "SEND_TEST_NOTIFICATION",
	CLOSE_SEND_TEST_NOTIFICATION_NOTIFICAION = "CLOSE_SEND_TEST_NOTIFICATION_NOTIFICAION",
	GET_SIMCARDS = "GET_SIMCARDS",
	UPDATE_SIMCARD_SUCCESS = "UPDATE_SIMCARD_SUCCESS",
	UPDATE_SIMCARD_FAILED = "UPDATE_SIMCARD_FAILED",
	CREATE_SIMCARD_FAILED = "CREATE_SIMCARD_FAILED",
	CREATE_SIMCARD_SUCCESS = "CREATE_SIMCARD_SUCCESS",
	DELETE_SIMCARD_SUCCESS = "DELETE_SIMCARD_SUCCESS",
	DELETE_SIMCARD_FAILED = "DELETE_SIMCARD_FAILED",
	CLOSE_UPDATE_SIMCARD_SUCCESS_NOTIFICATION = "CLOSE_UPDATE_SIMCARD_SUCCESS_NOTIFICATION",
	CLOSE_UPDATE_SIMCARD_FAIL_NOTIFICATION = "CLOSE_UPDATE_SIMCARD_FAIL_NOTIFICATION",
	CLOSE_CREATE_SIMCARD_SUCCESS_NOTIFICATION = "CLOSE_CREATE_SIMCARD_SUCCESS_NOTIFICATION",
	CLOSE_CREATE_SIMCARD_FAIL_NOTIFICATION = "CLOSE_CREATE_SIMCARD_FAIL_NOTIFICATION",
	GET_NODES_VERY_SHORT = "GET_NODES_VERY_SHORT",
	GET_SIMCARD_ASSIGNMENTS = "GET_SIMCARD_ASSIGNMENTS",
	GET_SIMCARD = "GET_SIMCARD",
	GET_SYSTEMS_NODES_ROUTERS_SHORT = "GET_SYSTEMS_NODES_ROUTERS_SHORT",
	GET_ROUTERS = "GET_ROUTERS",
	GET_ROUTER_ASSIGNMENTS = "GET_ROUTER_ASSIGNMENTS",
	GET_ROUTER = "GET_ROUTER",
	UPDATE_ROUTER_SUCCESS = "UPDATE_ROUTER_SUCCESS",
	UPDATE_ROUTER_FAILED = "UPDATE_ROUTER_FAILED",
	CREATE_ROUTER_FAILED = "CREATE_ROUTER_FAILED",
	CREATE_ROUTER_SUCCESS = "CREATE_ROUTER_SUCCESS",
	DELETE_ROUTER_SUCCESS = "DELETE_ROUTER_SUCCESS",
	DELETE_ROUTER_FAILED = "DELETE_ROUTER_FAILED",
	CLOSE_UPDATE_ROUTER_SUCCESS_NOTIFICATION = "CLOSE_UPDATE_ROUTER_SUCCESS_NOTIFICATION",
	CLOSE_UPDATE_ROUTER_FAIL_NOTIFICATION = "CLOSE_UPDATE_ROUTER_FAIL_NOTIFICATION",
	CLOSE_CREATE_ROUTER_SUCCESS_NOTIFICATION = "CLOSE_CREATE_ROUTER_SUCCESS_NOTIFICATION",
	CLOSE_CREATE_ROUTER_FAIL_NOTIFICATION = "CLOSE_CREATE_ROUTER_FAIL_NOTIFICATION",
	GET_FREE_SIMCARDS = "GET_FREE_SIMCARDS",
	GET_SMSES = "GET_SMSES",
	SMSES_LOADING = "SMSES_LOADING",
	SEND_SMS = "SEND_SMS",
	GET_ROUTERS_WITH_SIMCARDS = "GET_ROUTERS_WITH_SIMCARDS",
	GET_NODES_WITH_SIMCARDS = "GET_NODES_WITH_SIMCARDS",
	GET_SYSTEMS_FOR_TABLE = "GET_SYSTEMS_FOR_TABLE",
	GET_ALT_MAPS = "GET_ALT_MAPS",
	CLOSE_DELETE_MAP_NOTIFICATION = "CLOSE_DELETE_MAP_NOTIFICATION",
	DELETE_MAP_SUCCEEDED = "DELETE_MAP_SUCCEEDED",
	DELETE_MAP_FAILED = "DELETE_MAP_FAILED",
	CREATE_NODE_IMAGE_FAILED = "CREATE_NODE_IMAGE_FAILED",
	CREATE_NODE_IMAGE_SUCCESS = "CREATE_NODE_IMAGE_SUCCESS",
	DELETE_NODE_IMAGE_SUCCESS = "DELETE_NODE_IMAGE_SUCCESS",
	DELETE_NODE_IMAGE_FAILED = "DELETE_NODE_IMAGE_FAILED",
	GET_NODE_IMAGES = "GET_NODE_IMAGES",
	RESET_NODE_IMAGE_FLAGS = "RESET_NODE_IMAGE_FLAGS",
	SET_SERVICE_MODE = "SET_SERVICE_MODE",
	CLOSE_SET_SERVICE_MODE_NOTIFICAION = "CLOSE_SET_SERVICE_MODE_NOTIFICAION",
	RESET_SENSOR_ERROR_COUNTS = "RESET_SENSOR_ERROR_COUNTS",
	CLOSE_RESET_SENSOR_ERROR_COUNTS_NOTIFICATION = "CLOSE_RESET_SENSOR_ERROR_COUNTS_NOTIFICATION",
	GET_SYNC_FAILURES = "GET_SYNC_FAILURES",
	SET_SYSTEM_NOTIFICATIONS = "SET_SYSTEM_NOTIFICATIONS",
	CLOSE_SET_SYSTEM_NOTIFICATIONS_NOTIFICATION = "CLOSE_SET_SYSTEM_NOTIFICATIONS_NOTIFICATION",
	SET_SYSTEM_PROBLEMS_CONFIRMED = "SET_SYSTEM_PROBLEMS_CONFIRMED",
	GET_SYSTEM_DETAILS = "GET_SYSTEM_DETAILS",
	GET_DEVICE_DETAILS = "GET_DEVICE_DETAILS",
	GET_DEVICE_ERRORS = "GET_DEVICE_ERRORS",
	GET_DEVICE_ERRORS_COUNT = "GET_DEVICE_ERRORS_COUNT",
	DEVICE_ERRORS_LOADING = "DEVICE_ERRORS_LOADING"

}
